<template>

</template>

<script>
  export default {
    name: "course.vue",
    mounted: function () {
      window.location.href="https://www.pingxingyun.com/console/api/poc/hostAppli/start?appliId=1224648920978685952&codeRate=10000&frameRate=60&language=zh-CN"
    },
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DLMZ/course.vue